import React from 'react';
import { DefaultInvoiceTemplate } from './components';
import { useDocuments } from './hooks';

export default function ConfigurationDocuments() {
  const { invoiceTemplate, loading, error } = useDocuments();

  return <DefaultInvoiceTemplate template={invoiceTemplate} loading={loading} error={error} />;
}
